import React from 'react';
import { motion } from 'framer-motion';
import { OrderBar } from '../components/OrderBar';
import { MenuCategories } from '../components/MenuCategories';
interface MenuPageProps {
  onNavigate: (page: string) => void;
}
export function MenuPage({
  onNavigate
}: MenuPageProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.4
  }} className="min-h-screen bg-cream pb-20" data-id="element-568">
      <OrderBar data-id="element-569" />
      <div className="relative pt-16 pb-8 overflow-hidden" data-id="element-570">
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: 'url(https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/egg-stew.jpg?fit=696%2C464&ssl=1)'
      }} data-id="element-571" />
        <div className="absolute inset-0 bg-cream/85" data-id="element-572" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-8 relative z-10" data-id="element-573">
          <h1 className="font-heading text-5xl md:text-6xl text-charcoal uppercase tracking-wide" data-id="element-574">
            Our <span className="text-victory-red" data-id="element-575">Menu</span>
          </h1>
          <p className="font-body text-lg text-charcoal/70 mt-6 max-w-2xl mx-auto leading-relaxed" data-id="element-576">
            Experience the rich, authentic flavors of West Africa. From hearty
            stews and soups to perfectly seasoned rice dishes, every meal is
            prepared with fresh, organic ingredients and a whole lot of soul.
          </p>
        </div>
      </div>
      <MenuCategories onNavigate={onNavigate} data-id="element-577" />
    </motion.div>;
}